import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { Dialog } from 'primeng/dialog';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent implements OnInit {
    /**
     * @article: Angular: How to pass template with component as Input using ngTemplateOutlet
     * https://medium.com/@matsal.dev/angular-how-to-pass-template-with-component-as-input-using-ngtemplateoutlet-1d7ba9eeadd6
     */

    @Input() title: string;
    @Input() template: TemplateRef<any>;
    @Input() disabled: boolean;
    @Input() disabledCancel: boolean;
    @Input() hasInnerMenu = false;
    @Output() accepted = new EventEmitter<boolean>();

    display = false;

    constructor() {}

    ngOnInit(): void {
        // DO NOTHING
    }

    showDialog(): void {
        this.display = true;
    }

    closeDialog(): void {
        this.display = false;
    }

    showDialogMaximized(dialog: Dialog) {
        setTimeout(() => {
            dialog.maximize();
        }, 0);
    }

    acceptDialog(): void {
        this.accepted.emit(true);
        this.closeDialog();
    }

    cancelDialog(): void {
        this.accepted.emit(false);
        this.closeDialog();
    }

    noOp(): void {
        // DO NOTHING
    }
}
